<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/TbciMq/media/FC-9781645759706.jpg?1684514751617" alt="This image is the cover for the book Speakers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Speakers
      </h1>
      <p class="bookDescription body article font2">
        <p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;'><span style='font-family:"Arial",sans-serif;color:black;background:white;'>While the Alsoo refugees on Earth learn about and explore their new home world, those Also</span><span style='font-family:"Arial",sans-serif;color:black;background:white;'>o</span><span style='font-family:"Arial",sans-serif;color:black;background:white;'> that remained behind explore a home</span><span style='font-family:"Arial",sans-serif;color:black;background:white;'> </span><span style='font-family:"Arial",sans-serif;color:black;background:white;'>world changed beyond recognition. </span></p><p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;'><span style='font-family:"Arial",sans-serif;color:black;background:white;'>Both </span><span style='font-family:"Arial",sans-serif;color:black;background:white;'>groups will find </span><span style='font-family:"Arial",sans-serif;color:black;background:white;'>new dangers and new obstacles to overcome</span><span style='font-family:"Arial",sans-serif;color:black;background:white;'> as they seek to rebuild their lives…</span></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Henry A. Burns
      </h2>
      
      <p class="authorDescription body article"><p class="BodyA" style='margin:0cm;margin-bottom:.0001pt;font-size:16px;font-family:"Times New Roman",serif;color:black;text-align:justify;'><span style="font-size:15px;">Henry A. Burns was born in Brooklyn, New York. He wrote his first story, <em>The Sunshine Car,</em> when he was five. He studied drama and acting in junior high and high school to get over his innate shyness. After college, writing was put on hold to pursue a career. Now retired, he lives in San Francisco with his wife, his cats, and three bearded dragons. <em>Speakers</em> is his third published book.</span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?019d2136